//constant
const EN_PAGE = '/zu/pages/home-page-english';
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded and parsed');

  // Check if the URL is /zu/pages/en and update the menu item
  if (window.location.pathname === EN_PAGE) {
    var menuItem = document.getElementById('HeaderMenu-lazy-diet健康餐');
    if (menuItem) {
      var menuItemSpan = menuItem.querySelector('span');
      if (menuItemSpan) {
        menuItemSpan.classList.add('header__active-menu-item');
      }
    }
  }

  // Update links pointing to /zu to /zu/pages/en
  var links = document.querySelectorAll('a[href="/zu"]');
  links.forEach(function(link) {
    link.setAttribute('href', EN_PAGE);
  });

  // Function to get the active language
  function getActiveLanguage() {
    const activeLanguageLink = document.querySelector('.disclosure__link--active');
    return activeLanguageLink ? activeLanguageLink.getAttribute('data-value') : 'en';
  }

  // Function to redirect based on active language
  function redirectBasedOnLanguage() {
    const activeLanguage = getActiveLanguage();
    console.log('Active language:', activeLanguage);

    if (window.location.pathname === EN_PAGE && activeLanguage === 'en') {
      window.location.href = '/';
      return;
    }

    let redirectUrl = '/';

    switch (activeLanguage) {
      case 'zu':
        redirectUrl = EN_PAGE; // URL for Simplified Chinese
        break;
      case 'en':
      default:
        redirectUrl = '/'; // Default homepage
        break;
    }

    console.log('Redirecting to:', redirectUrl);
    if (window.location.pathname === '/' && window.location.pathname !== redirectUrl) {
      window.location.href = redirectUrl;
    }
  }

  // Initial redirection based on the current active language if on the homepage
  if (window.location.pathname === '/') {
    redirectBasedOnLanguage();
  }

  // Add event listeners to language links
  const languageLinks = document.querySelectorAll('.disclosure__link');
  languageLinks.forEach(function(link) {
    if (link.getAttribute('data-value') === 'en') {
       link.textContent = 'Mandarin';
    } else if (link.getAttribute('data-value') === 'zu') {
       link.textContent = 'English';
    }

    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default link behavior
      languageLinks.forEach(l => l.classList.remove('disclosure__link--active'));
      this.classList.add('disclosure__link--active');
      // Special case handling for /zu/pages/en to /
      if (window.location.pathname === EN_PAGE && this.getAttribute('data-value') === 'en') {
        window.location.href = '/';
      } else if (window.location.pathname === '/') {
        redirectBasedOnLanguage();
      } else {
        console.log('Language changed on non-homepage, no redirect.');
      }
    });
    
  });

  // Conditional to remove /zu from the URL if it does not contain /zu/pages/en
  

  
});
